export default __webpack_public_path__ + "static/media/LOGO.128c23fc.png";